// extracted by css-extract-rspack-plugin
export default {"etSpinner":"_3Fe0s"};